export default /* @ngInject */ () => {
	return (val) => {
		return Math.abs(val);
	};
};
